import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initFirebase } from "./firebase";
import "./mobile.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

initFirebase().then(() => {
  root.render(<React.StrictMode><App /></React.StrictMode>);
});
